var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRow',[_c('VCol',{attrs:{"cols":"12"}},[(_vm.fileList.length > 0)?_c('SrDropzoneUploadFileList',{attrs:{"value":_vm.fileList},on:{"removeFile":_vm.removeFile}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }